import { useCallback, useLayoutEffect, useMemo, useRef } from 'react'
import { IUserBbox } from '@/api/user/getUsersBbox.ts'
import { createClusterIndex, getClusterMarkers, resolveClusterSelection } from '@/pages/dashboard/dashboardClusters.ts'

export const useDashboardClusters = (
    users: IUserBbox[] | undefined,
    zoomLevel: number,
    getRank: (user: IUserBbox) => number,
    highRankOnTop = false
) => {
    const index = useMemo(() => createClusterIndex(users ?? [], getRank), [users, getRank])
    const markers = useMemo(() => getClusterMarkers(index, zoomLevel, highRankOnTop), [index, zoomLevel, highRankOnTop])
    const latest = useRef({ index, markers, zoomLevel })

    useLayoutEffect(() => {
        latest.current = { index, markers, zoomLevel }
    })

    const selectMarker = useCallback((key: string) => {
        const { index, markers, zoomLevel } = latest.current
        const marker = markers.find((item) => item.key === key)
        return marker ? resolveClusterSelection(index, marker, zoomLevel) : undefined
    }, [])

    return { markers, selectMarker }
}
